import { z } from 'zod';

import { LosId, WriteoffId } from '../../BrandedIds';
import { zodTemporalInstant, zodTemporalPlainDate } from '../../Temporal';

export const ExportableWriteoff = z
  .object({
    id: WriteoffId,
    loanId: LosId,

    effectiveDate: zodTemporalPlainDate,
    status: z.enum(['active']),
    escrow: z.number(),
    suspense: z.number(),
    comment: z.string().optional(),
    createdAt: zodTemporalInstant,
    updatedAt: zodTemporalInstant,
  })
  .meta({ title: 'Writeoff' });

export type ExportableWriteoff = z.infer<typeof ExportableWriteoff>;
